module.exports = __webpack_public_path__ + "static/3-d7f8b61c0a2fcfae06753cd4154aa8d6.png";